import React from 'react';

type Props = {
    onClick?: () => void;
    children: React.ReactNode;
    icon?: React.ReactNode;
    type?: 'primary' | 'secondary';
    isLoading?: boolean;
    className?: string;
};

class AntButton extends React.PureComponent<Props> {
    render(): React.ReactNode {
        const { onClick, children, icon, type, isLoading, className } = this.props;
        return (
            <button
                onClick={onClick}
                className={`h-36 px-16 btn-small rounded-8 ${
                    type === 'primary'
                        ? 'bg-darwin-accent-bright-blue-800 text-white'
                        : 'bg-white text-darwin-accent-bright-blue-800 border border-darwin-accent-bright-blue-800'
                } text-14 font-700 flex space-x-4 items-center ${className}`}
            >
                {isLoading ? (
                    <svg
                        width="24"
                        height="24"
                        version="1.1"
                        id="L4"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        viewBox="0 0 100 100"
                        enableBackground="new 0 0 0 0"
                    >
                        <circle fill="#003BA8" stroke="none" cx="6" cy="50" r="6">
                            <animate
                                attributeName="opacity"
                                dur="1s"
                                values="0;1;0"
                                repeatCount="indefinite"
                                begin="0.1"
                            />
                        </circle>
                        <circle fill="#003BA8" stroke="none" cx="26" cy="50" r="6">
                            <animate
                                attributeName="opacity"
                                dur="1s"
                                values="0;1;0"
                                repeatCount="indefinite"
                                begin="0.2"
                            />
                        </circle>
                        <circle fill="#003BA8" stroke="none" cx="46" cy="50" r="6">
                            <animate
                                attributeName="opacity"
                                dur="1s"
                                values="0;1;0"
                                repeatCount="indefinite"
                                begin="0.3"
                            />
                        </circle>
                    </svg>
                ) : (
                    icon
                )}
                <span className={`w-full text-center ${'text-13'}`}>{children}</span>
            </button>
        );
    }
}

export default AntButton;
